import { createFileRoute } from '@tanstack/react-router'
import { RequirePermission } from '@/features/rbac/components/require-permission'
import { UserOverviewPage } from '@/features/users/overview'

function UserOverviewRoute() {
  const { userId } = Route.useParams()

  return (
    <RequirePermission permission='user.view'>
      <UserOverviewPage userId={userId} />
    </RequirePermission>
  )
}

export const Route = createFileRoute('/_authenticated/users/$userId')({
  component: UserOverviewRoute,
})
